import Vue from 'vue'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import "vue-select/dist/vue-select.css"
import vSelect from "vue-select";
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import Notifications from 'vue-notification'
import Vuelidate from 'vuelidate'
import '@plugins/veeValidate'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
// import VueFullscreen from 'vue-fullscreen'
// https://dobromir-hristov.github.io/vuelidate-error-extractor/other_frameworks.html#usage-with-bootstrapvue
import VuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor'
import App from './App'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import FormGroup from '@components/FormGroup'
import FormSummary from '@components/FormSummary'
import TriduumBase from '@plugins/triduumBase'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import i18n from '@plugins/i18n'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
library.add(fas, fab)


import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

import './registerServiceWorker'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}
Vue.config.silent = true;

Vue.config.errorHandler = function (err, vm, info) {
  const JumpError = ['cloneNode','vuex']
  if (!JumpError.some(v => err.toString().includes(v))) {
    console.error(`Error: ${err.toString()}\nInfo: ${info}`)
    console.log(`Error:`, err)
  }
}
Vue.config.warnHandler = function (msg, vm, trace, other) {
  // console.log(`Warn: `, msg)
  // console.log("trace:", trace)
}

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Datetime)
Vue.use(Vuelidate)
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

Vue.use(VuelidateErrorExtractor, {
  templates,
  i18n: 'validation',
})

Vue.use(Notifications)
Vue.use(TriduumBase)

Vue.use(VueLodash, { name: 'custom', lodash: lodash })
// Vue.use(VueFullscreen)

Vue.component('FormGroup', FormGroup)
Vue.component('FormSummary', FormSummary)
Vue.component('formWrapper', templates.FormWrapper)
Vue.component('datetime', Datetime)
Vue.component('v-select', vSelect)
Vue.component('date-picker', DatePicker)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.use(FontAwesomeIcon)
Vue.use(require('vue-moment'))

Vue.filter('substring', function (value, limit) {
  if (value.length > limit) {
    value = value.substring(0, limit)
  }
  return value
})

Vue.filter('minuscule', function (value) {
  return value.toLowerCase()
})

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
